import { render, staticRenderFns } from "./AdminLogin.vue?vue&type=template&id=4f65e33b&scoped=true"
import script from "./AdminLogin.vue?vue&type=script&lang=js"
export * from "./AdminLogin.vue?vue&type=script&lang=js"
import style0 from "./AdminLogin.vue?vue&type=style&index=0&id=4f65e33b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f65e33b",
  null
  
)

export default component.exports